import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Container } from 'reactstrap';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Input } from 'reactstrap';
import Main from '../../layout/main';
import EditServiceTypes from "../../components/profile/editServiceTypes";
import { connect } from 'react-redux';
import EmailUpdate from "../../components/profile/emailUpdate";
import MobileNumberUpdate from "../../components/profile/mobileNumberUpdate";
import UploadProfilePic from "../../components/profile/profileImageUpdate";
import ResetPassword from "../../components/profile/resetPassword";
import validate from "../../components/profile/profileValidation";
import { updateProfile } from "../../redux/actions/updateProfile"
import ProfileLoader from "../../components/profile/profileSkeleton";
class Profile extends Component {
    constructor(props) {
        super(props);
        const editProfileItems = this.props.editProfile.profileEdit
        this.state = {
            editMode: true,
            fieldsUpdated: false,

            altranatePhone: "",
            street_address: "",
            zipcode: "",
            company_name: "",
            companyType: 2,
            google_id: "",
            yelp_id: "",
            insurance_number: "",
            license_number: "",
            years_of_business: null,
            cityRadius: [],

            companyNameError: "",
            altranatePhoneError: "",
            street_addressError: "",
            zipcodeError: "",
            companyTypeError: "",
            google_idError: "",
            yelp_idError: "",
            insurance_numberError: "",
            license_numberError: "",
            years_of_businessError: "",
            project_type_ids: [],
            project_sub_type_ids: [],
            provider_locations_attributes: [],
            cityRadiusError: "",
            serviceError: "",
            showmoreService: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.editSave = this.editSave.bind(this);
    }
    componentDidMount() {
        const { street_address,
            phone_number2,
            zipcode,
            company_name,
            company_type,
            google_id,
            yelp_id,
            insurance_number,
            license_number,
            years_of_business,
            project_types,
            project_sub_types,
            provider_locations
        } = this.props.profileData;
        const proSubTypes = [];
        const proTypes = [];
        project_sub_types && project_types.forEach((types => {
            proTypes.push(types.id);
        }))
        project_sub_types && project_sub_types.forEach((stypes => {
            proSubTypes.push(stypes.id);
        }))
        this.setState({
            altranatePhone: phone_number2,
            street_address: street_address,
            zipcode: zipcode,
            company_name: company_name,
            companyType: company_type,
            google_id: google_id,
            yelp_id: yelp_id,
            insurance_number: insurance_number,
            license_number: license_number,
            years_of_business: years_of_business,
            project_type_ids: proTypes,
            project_sub_type_ids: proSubTypes,
            provider_locations_attributes: provider_locations,
        })
    }

    clearErrors = () => {
        this.setState({
            companyNameError: "",
            altranatePhoneError: "",
            street_addressError: "",
            zipcodeError: "",
            companyTypeError: "",
            google_idError: "",
            yelp_idError: "",
            insurance_numberError: "",
            license_numberError: "",
            years_of_businessError: "",
            serviceError: "",
            cityRadiusError: ""
        })
    }
    handleChange(event) {
        this.setState({ editMode: event.target.value });
        () => this.clearErrors();
    }
    editSave = (event) => {
        event.preventDefault();
        const errors = validate(this.state);
        this.setState({ ...errors })
        let data = JSON.stringify({
            provider: {
                phone_number2: this.state.altranatePhone,
                street_address: this.state.street_address,
                zipcode: this.state.zipcode,
                company_name: this.state.company_name,
                company_type: this.state.companyType,
                google_id: this.state.google_id,
                yelp_id: this.state.yelp_id,
                years_of_business: this.state.years_of_business,

                insurance_number: this.state.insurance_number,
                license_number: this.state.license_number,

                project_type_ids: this.state.project_type_ids,
                project_sub_type_ids: this.props.selectedTypes.selectedSubTypes,
                provider_locations_attributes: this.state.cityRadius
            }
        })
        errors.valid && this.setState({ editMode: true })
        errors.valid && this.props.updateProfile(data);
        errors.valid && this.props.getLatest();
    }
    // Started Modal Box Open Function 
    state = {
        isOpen: false,
        editItem: null,
        file: null,
        fileName: null,
        editStatus: "9898",
        error: "",
        value: "",
        altranatePhone: 8129,
    };

    openModal = (id) => this.setState({ isOpen: true, editItem: id });
    //closeModal = () => this.setState({ isOpen: false });
    toggleModal = () => this.setState({ isOpen: false });
    // Ended Modal Box Open Function 

    handleChangeFile(event) {
        this.setState({
            file: URL.createObjectURL(event.target.files[0]),
            fileName: event.target.files[0]
        })
    }

    //   handleChange(e) {
    //       this.setState({
    //         editStatus: e.target.value
    //       })

    //   }

    handleRegisterServices = (types, subTypes, storeBusiness) => {
        const locationAtt = storeBusiness.provider_locations_attributes;

        let selected_cities = []
        for (let index = 0; index < locationAtt && locationAtt.length; index++) {
            const location = this.state.locationAtt[index];

            selected_cities.push({
                location_name: location.cityName,
                city: location.cityName,
                state: location.state,
                state_short: location.state_short,
                country: location.country,
                radius: locationAtt[index].radius
            })
        }

    }
    handleInputChange = (event) => {
        const name = event.target.name;
        this.setState({
            [name]: event.target.value,
            fieldsUpdated: true,
            companyNameError: "",
            altranatePhoneError: "",
            street_addressError: "",
            zipcodeError: "",
            companyTypeError: "",
            google_idError: "",
            yelp_idError: "",
            insurance_numberError: "",
            license_numberError: "",
            years_of_businessError: "",
            cityRadiusError: "",
            serviceError: "",
        })
    }
    handleTypeSubmit = (data) => {
        this.setState({ fieldsUpdated: true });
    };
    convertPRoviderLocation = (locations) => {
        let out = [];
        locations && locations.length != 0 && locations.forEach(x => {
            out.push({
                location_name: x.city,
                radius: x.radius,
                id: x.id,
                state_short: x.state_short,
                state: x.state
            })
        });
        return out;
    }
    handleChangeCityRadius = (data) => {
        let selected_cities = []
        // selected_cities.push({
        //     id: location.id,
        //     location_name: location.location_name,
        //     city: location.city,
        //     state: location.state,
        //     state_short: location.state_short,
        //     country: location.country,
        //     _destroy: location.destroy,
        //     radius: location.radius
        // })
        this.setState({ cityRadius: data })
    }
    setPropsToState = (editProfileItems) => {
        // this.setState({
        //     altranatePhone: editProfileItems.phone_number2,
        //     street_address: editProfileItems.street_address,
        //     zipcode: editProfileItems.zipcode,
        //     company_name: editProfileItems.company_name,
        //     companyType: editProfileItems.company_type,
        //     google_id: editProfileItems.google_id,
        //     yelp_id: editProfileItems.yelp_id,
        //     insurance_number: editProfileItems.insurance_number,
        //     license_number: editProfileItems.license_number,
        //     years_of_business: editProfileItems.years_of_business,
        // })
    }
    setValue = () => {
        this.setState({ editMode: !this.state.editMode })
    }
    capitalize = (str) => {
        const str2 = str && str.charAt(0).toUpperCase() + str.slice(1);
        return str2
    }
    setChangedServices = (data) => {
        this.setState({ project_sub_type_ids: data })
    };
    showMoreservice = () => {
        this.setState({ showmoreService: !this.state.showmoreService })
    }
    shareWith = () => {

    }
    render() {
        const editProfileItems = this.props.editProfile.profileEdit
        this.props.editProfile && this.props.editProfile.profileEdit && this.setPropsToState(this.props.editProfile.profileEdit)
        const profileItems = this.props.profile.profile
        const { serviceTypesData, authData } = this.props;
        const companies = [
            { label: "Company Type", value: "0" },
            { label: "Sole Proprietor", value: "1" },
            { label: "LLC", value: "2" },
            { label: "Corp", value: "3" }
        ];
        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>My Account</title>
                    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
                </Helmet>
                <Main additionalClass_main="profile pb-0">
                    <section className="ebw-section__pages ebw-section__profile d-flex align-items-center justify-content-center">
                        <Container className="ebw-profile__inwrap">
                            {this.props.ProfileDataLoading ?
                                <ProfileLoader />
                                :
                                <div className="ebw-profile__row d-flex align-items-center justify-content-center">
                                    <div className="ebw-profile__col ebw-profile__col-left">
                                        <div className="ebw-profile__col-wrap">
                                            <div className="ebw-profile__title ebw-title__primary mb-3 text-black">Edit Profile</div>
                                            <div className="ebw-profile__content d-md-flex d-lg-block">
                                                <div style={{ backgroundImage: `url(${profileItems && profileItems.avatar && profileItems.avatar})` }} className="ebw-profile__img d-flex align-items-end justify-content-center mb-3">
                                                    <UploadProfilePic />
                                                </div>
                                                <div className="ebw-profile__content-right">
                                                    <div className="ebw-profile__name-wrap d-flex align-items-center mt-7">
                                                        <div className="ebw-profile__name mr-4">{profileItems.name}</div>
                                                    </div>
                                                    <EmailUpdate email={profileItems.email} />
                                                    <MobileNumberUpdate mobile_number={profileItems.mobile_number} />
                                                    <ResetPassword email={profileItems.email} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                        </Container>
                    </section>

                    {/* Started Modal Box */}
                    <div className="ebw-profile__modal">

                        <Modal isOpen={this.state.isOpen} toggle={this.toggleModal}>
                            {this.state.editItem == "services" ?

                                <div className="px-5 py-5 ebw-modal__wrap">
                                    <ModalHeader toggle={this.toggleModal} className="ebw-profile__modal-head" style={{ border: "none" }}>
                                        <div className="ebw-modal__title mb-1">Service List</div>
                                    </ModalHeader>
                                    <ModalBody className="ebw-modal__body">
                                        {this.state.editMode ?
                                            <>
                                                {editProfileItems.project_sub_types.map((serviceItem, index) => {
                                                    return (
                                                        <div key={index} className="mb-2">{serviceItem.name}</div>
                                                    )
                                                })}
                                            </> :

                                            <EditServiceTypes
                                                projectSubTypes={editProfileItems.project_sub_types}
                                                serviceTypesData={serviceTypesData}
                                                selectedSubTypesPrev={editProfileItems.project_sub_types}
                                                closeModal={this.toggleModal}
                                                handleRegisterServices={this.handleTypeSubmit}
                                                setChangedServices={this.setChangedServices}
                                            />
                                        }
                                    </ModalBody>
                                </div>
                                :
                                this.state.editItem == "changeDP" ?
                                    <div className="px-5 py-5 ebw-modal__wrap">
                                        <ModalHeader toggle={this.toggleModal} className="ebw-profile__modal-head" style={{ border: "none" }}>
                                            <div className="ebw-modal__title mb-1">Reset your Password</div>
                                        </ModalHeader>
                                        <ModalBody className="ebw-modal__body">
                                            <form className="ebw-modal__form">
                                                <div className="ebw-modal__input-wrap mb-4">
                                                    <Input id="uploadDP" className="ebw-modal__input d-none" type="file" onChange={this.handleChange} required></Input>
                                                    <label for="uploadDP" className="ebw-my__uploads-file m-0 w-100">
                                                        <div className="ebw-my__uploads-inwrap text-center">
                                                            <div className="ebw-form__input ebw-profile__input-file--custom d-flex justify-content-between align-items-center btn btn-secondary">
                                                                <span className="ebw-form__input ebw-profile__input-file--text">Choose File</span>
                                                                {/* <span className="ebw-icon ebw-icon--xl icon-arrow-down"></span> */}
                                                            </div>
                                                            <p className="ebw-my__uploads-text pt-3">Or drop files here. Maximum file size is 10MB.</p>
                                                            {this.state.file ?
                                                                <div>
                                                                    <div style={{ backgroundImage: `url(${this.state.file})` }} className="ebw-my__uploads-img"></div>
                                                                    <div>{this.state.fileName.name}</div>
                                                                </div>
                                                                :
                                                                ""
                                                            }
                                                        </div>
                                                    </label>
                                                </div>
                                                <div className="text-right mt-5">
                                                    <button className="ebw-modal__submit ebw-button__primary" type="submit">Submit</button>
                                                </div>
                                            </form>
                                        </ModalBody>
                                    </div>

                                    :
                                    this.state.editItem == "changeDP" ?

                                        <div className="px-5 py-5 ebw-modal__wrap">
                                            <ModalHeader toggle={this.toggleModal} className="ebw-profile__modal-head" style={{ border: "none" }}>
                                                <div className="ebw-modal__title text-capitalize mb-1">Upload Profile Picture</div>
                                            </ModalHeader>
                                            <ModalBody className="ebw-modal__body">
                                                <form className="ebw-modal__form">
                                                    <div className="ebw-modal__input-wrap mb-4">
                                                        <Input id="uploadDP" className="ebw-modal__input d-none" type="file" onChange={this.handleChange} required></Input>
                                                        <label for="uploadDP" className="ebw-my__uploads-file m-0 w-100">
                                                            <div className="ebw-my__uploads-inwrap text-center">
                                                                <div className="ebw-form__input ebw-profile__input-file--custom d-flex justify-content-between align-items-center btn btn-secondary">
                                                                    <span className="ebw-form__input ebw-profile__input-file--text">Choose File</span>
                                                                    {/* <span className="ebw-icon ebw-icon--xl icon-arrow-down"></span> */}
                                                                </div>
                                                                <p className="ebw-my__uploads-text pt-3">Or drop files here. Maximum file size is 10MB.</p>
                                                                {this.state.file ?
                                                                    <div>
                                                                        <div style={{ backgroundImage: `url(${this.state.file})` }} className="ebw-my__uploads-img"></div>
                                                                        <div>{this.state.fileName.name}</div>
                                                                    </div>
                                                                    :
                                                                    ""
                                                                }
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div className="text-right">
                                                        <button className="ebw-modal__submit ebw-button__primary" type="submit">Update</button>
                                                    </div>
                                                </form>
                                            </ModalBody>
                                        </div>

                                        : ""
                            }
                        </Modal>
                    </div>
                    {/* Ended Modal Box */}
                </Main>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    profile: state.profileData,
    editProfile: state.getProfileEditData,
    serviceTypesData: state.serviceTypes,
    selectedTypes: state.selectedTypes,
    authData: state.auth,
    servedCities: state.servedCities.cities


});

export default connect(mapStateToProps, { updateProfile })(Profile);;
